var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpam3Line = function SvgSpam3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.542 3.45 5.008 5.01v7.083l-5.008 5.006H8.46l-5.01-5.007V8.459l5.01-5.01zm-.746 1.8H9.205L5.25 9.204v5.591l3.954 3.955h5.591l3.955-3.955V9.204zM8.4 11.1h7.2v1.8H8.4z"
  })));
};
export default SvgSpam3Line;